// Version : 0.0.1
// LastEdit : KARTHEESWARAN
// MODFIED DATE:12-11-2025
//Last ADD : REMOVE COMMENTED LINES

const AttendanceReportActionTypes = {
	/************ GET ATTENDANCE REPORT LIST START **********************/
	GET_ATTENDANCE_REPORT_LIST_START: 'get_attendance_report_start',
	GET_ATTENDANCE_REPORT_LIST_SUCCESS: 'get_attendance_report_success',
	GET_ATTENDANCE_REPORT_LIST_FAILURE: 'get_attendance_report_failure',
	GET_ATTENDANCE_REPORT_LIST_RESPONSE_RESET: 'get_attendance_report_response_reset',
	GET_ATTENDANCE_REPORT_LIST_RESPONSE_CHANGED: 'get_attendance_report_response_changed',
	/************ GET ATTENDANCE REPORT LIST START **********************/
};
export default AttendanceReportActionTypes;
